import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

import logo from "./images/logo.png";
import "./App.css";

import Home from "./components/Home";
import Viewer from "./components/Viewer";
import Upload from "./components/Upload";
import Guida from "./components/Guida";
import guida from "./images/back.svg";

function App() {
  return (
    <Router>
      <div className="App">
        <div className="logo-container">
		<Link to="/">
          <img
            src={logo}
            alt="Artlinea Fine Italian Jewelry"
            className="logo"
          />
		  </Link>
          <Link to="/">
            <img
              src={guida}
              alt="Torna alla home"
              className="back-home"
            />
          </Link>
        </div>

        {/* Routed pages */}
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/viewer" component={Viewer} />
          <Route path="/upload" component={Upload} />
          <Route path="/guida" component={Guida} />
          <Route path="*" component={Home} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
